import { IconSpinnerArrow } from '@components/Icon';
import { SrOnly } from '@components/SrOnly';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Spinner, SpinnerIconBottom, SpinnerIconTop, Wrapper } from './wrapper';

interface ILoader {
  inline?: boolean;
  inlineBlock?: boolean;
  style?: React.CSSProperties;
  color?: string;
  size?: number;
}

const Loader = ({ inline, inlineBlock, style, color, size }: ILoader) => {
  const { t } = useTranslation();

  return (
    <Wrapper $inline={inline} $inlineBlock={inlineBlock} style={style} $color={color} $size={size}>
      <Spinner aria-hidden="true" $color={color} $size={size}>
        <SpinnerIconTop style={{}} $color={color} $size={size}>
          <IconSpinnerArrow />
        </SpinnerIconTop>
        <SpinnerIconBottom $color={color} $size={size}>
          <IconSpinnerArrow />
        </SpinnerIconBottom>
      </Spinner>
      <SrOnly>{t('loader_screenreader_text')}</SrOnly>
    </Wrapper>
  );
};

export default Loader;
